import React, { useEffect, useState } from "react";
import { Chart, registerables } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import obtenerParticipantesPorTecnico from "../../../services/participants/getParticipantesPorTecnicoService";
import {
  notification,
  Button,
  Row,
  Col,
  Card,
  Table,
  Progress,
  Tag,
  Select,
  Spin,
  Drawer,
  Tooltip,
  List,
  Typography,
} from "antd";
import {
  UserOutlined,
  ManOutlined,
  WomanOutlined,
  CheckCircleOutlined,
  ReloadOutlined,
  BarsOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import ExportInformeGeneral from "./Exportable_informacionGeneral";
import Export_diagnostico_parte1 from "../Diagnostico/exportable/diagnostico_parte1_excel";
import Export_analisisCapacidades from "../AnalisisCapacidades/exportable/analisis_capaciaddes_excel";
import ChartCard from "../../charts/ChartCard";
import Export_autorizacion_imagen from "../Autorizacion_imagen/exportable.jsx/autorizacion_imagen_excel";
import Export_medicionCapacidadSalida from "../medicionCapacidadesSalida/exportable/medicion_capacidades_salida_excel";

const { Title } = Typography;

Chart.register(...registerables, ChartDataLabels);
const { Option } = Select;

const cardStyle = {
  textAlign: "center",
  borderRadius: 20,
  backgroundColor: "#ffffff",
  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
  padding: 20,
  height: "100%",
};

const iconContainerStyle = {
  width: 100,
  height: 100,
  borderRadius: "50%",
  backgroundColor: "#F44336",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  margin: "0 auto 10px",
};

const iconStyle = {
  fontSize: 40,
  color: "white",
};

const total = {
  fontSize: 40,
  color: "#333",
  margin: 0,
};

const InformeSeguimientoMonitoreo = () => {
  const [data, setData] = useState(null);
  const [dataOriginal, setDataOriginal] = useState(null);
  const [dataFilter, setDataFilter] = useState(null);

  const [visitasPorTipo, setVisitasPorTipo] = useState({});
  const [participantesPorDepartamento, setParticipantesPorDepartamento] =
    useState({});
  const [participantesPorMunicipio, setParticipantesPorMunicipio] = useState(
    {}
  );
  const [departamentoSeleccionado, setDepartamentoSeleccionado] =
    useState(null);
  const [municipioSeleccionado, setMunicipioSeleccionado] = useState(null);
  const [sectorSeleccionado, setSectorSeleccionado] = useState(null);
  const [tipoFormularioSeleccionado, setTipoFormularioSeleccionado] =
    useState(null);

  const [tableData, setTableData] = useState([]);
  const [participantesPorSector, setParticipantesPorSector] = useState({});
  const [participantesPorSexo, setParticipantesPorSexo] = useState({});

  const [listDepartamento, setListDepartamento] = useState([]);
  const [listMunicipio, setListMunicipio] = useState([]);
  const [listSector, setListSector] = useState([]);
  const [listTipoformulario, setListTipoformulario] = useState([]);

  const [listMunicipiosPorDepartamento, setListMunicipiosPorDepartamento] =
    useState(null);

  const [registrados, setRegistrados] = useState(0);
  const [pendientes, setPendientes] = useState(0);
  const [totalParticipantes, setTotalParticipantes] = useState(0);

  const [drawerVisible, setDrawerVisible] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  // Lista de informes con sus respectivos componentes
  const informes = [
    { titulo: "Informe General", componente: <ExportInformeGeneral /> },
    { titulo: "Diagnóstico", componente: <Export_diagnostico_parte1 /> },
    {
      titulo: "Análisis de Capacidades",
      componente: <Export_analisisCapacidades />,
    },
    {
      titulo: "Autorización de imagen",
      componente: <Export_autorizacion_imagen />,
    },
    {
      titulo: "Medición de Capacidades de Salida",
      componente: <Export_medicionCapacidadSalida />,
    },
  ];

  const sectores = ["Pecuaria", "Agrícola", "Servicios"];
  const tipoFormularios = [
    "Consentimiento",
    "Diagnóstico",
    "Análisis de capacidades",
    "Autorizacion de imagen",
    "Acta de inicio",
    "Medición de capacidades de salida",
  ];

  const usernameFromState = useSelector((state) => state.auth.user);
  const fetchData = async () => {
    try {
      const response = await obtenerParticipantesPorTecnico(
        usernameFromState.email
      );
      const { estado, participantes } = response;

      if (estado) {
        setData(participantes);
        setDataOriginal(participantes); // Guarda la data original
        setDataFilter(participantes);
        const departamentos = [
          ...new Set(participantes.map((p) => p.departamento)),
        ];

        // Si el usuario tiene departamentos asignados
        if (
          usernameFromState?.departamento &&
          usernameFromState.departamento.length > 0
        ) {
        }

        setListDepartamento(departamentos);
        // Agrupar municipios por departamento
        const municipiosPorDepartamento = participantes.reduce((acc, p) => {
          if (!acc[p.departamento]) {
            acc[p.departamento] = new Set();
          }
          acc[p.departamento].add(p.municipio);
          return acc;
        }, {});
        //Almacenamos la lista de municipios por departamento
        setListMunicipiosPorDepartamento(municipiosPorDepartamento);
        setListSector(sectores);
        setListTipoformulario(tipoFormularios);
        procesarDatos(participantes);
      } else {
        notification.error({ message: response.message });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "An error occurred while fetching data.",
      });
    }
  };

  const procesarDatos = (participantes) => {
    const visitasPorTipoTemp = {};
    const participantesPorDepartamentoTemp = {};
    const participantesPorSectorTemp = {};
    const participantesPorSexoTemp = {};
    let totalRegistrados = 0;
    let totalPendientes = 0;

    const colores = ["#556F8F", "#145BAD", "#15CCCB", "#5B93D3", "#D0E0F2"];
    let colorIndex = 0;
    participantes.forEach((p) => {
      participantesPorSectorTemp[p.sector] =
        (participantesPorSectorTemp[p.sector] || 0) + 1;
      participantesPorSexoTemp[p.sexo_sir] =
        (participantesPorSexoTemp[p.sexo_sir] || 0) + 1;
      participantesPorDepartamentoTemp[p.departamento] =
        (participantesPorDepartamentoTemp[p.departamento] || 0) + 1;
      const completados = p.detalles.filter(
        (form) => form.estado === "registrado"
      ).length;

      if (completados === p.detalles.length) {
        totalRegistrados++;
      } else {
        totalPendientes++;
      }
      p.detalles.forEach((d) => {
        if (!visitasPorTipoTemp[d.visita]) {
          visitasPorTipoTemp[d.visita] = {
            registrado: 0,
            pendiente: 0,
            color: colores[colorIndex % colores.length],
          };
          colorIndex++;
        }
        visitasPorTipoTemp[d.visita][
          d.registrado === "true" ? "registrado" : "pendiente"
        ]++;
      });
    });

    setVisitasPorTipo(visitasPorTipoTemp);
    setParticipantesPorSector(participantesPorSectorTemp);
    setParticipantesPorSexo(participantesPorSexoTemp);
    setParticipantesPorDepartamento(participantesPorDepartamentoTemp);
    setRegistrados(totalRegistrados);
    setPendientes(totalPendientes);
    setTotalParticipantes(participantes.length);
    setDataFilter(participantes);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (!data) return;

    let participantesFiltrados = [...data];

    if (departamentoSeleccionado) {
      participantesFiltrados = data.filter(
        (p) => p.departamento === departamentoSeleccionado
      );
      const municipiosTemp = {};
      participantesFiltrados.forEach((p) => {
        municipiosTemp[p.municipio] = (municipiosTemp[p.municipio] || 0) + 1;
      });

      // Lista de municipios filtrados por el departamento seleccionado
      const municipios = departamentoSeleccionado
        ? [...listMunicipiosPorDepartamento[departamentoSeleccionado]]
        : [];
      setListMunicipio(municipios);
      setParticipantesPorMunicipio(municipiosTemp);
    }

    if (municipioSeleccionado) {
      participantesFiltrados = participantesFiltrados.filter(
        (p) => p.municipio === municipioSeleccionado
      );
      const municipiosTemp = {};
      participantesFiltrados.forEach((p) => {
        municipiosTemp[p.municipio] = (municipiosTemp[p.municipio] || 0) + 1;
      });
      setParticipantesPorMunicipio(municipiosTemp);
    }

    if (sectorSeleccionado) {
      participantesFiltrados = participantesFiltrados.filter(
        (p) => p.sector === sectorSeleccionado
      );
    }

    if (tipoFormularioSeleccionado) {
      participantesFiltrados = participantesFiltrados
        .map((p) => ({
          ...p,
          detalles:
            p.detalles?.filter(
              (detalle) => detalle.visita === tipoFormularioSeleccionado
            ) ?? [],
        }))
        .filter((p) => p.detalles.length > 0);
    }

    procesarDatos(participantesFiltrados);
  }, [
    departamentoSeleccionado,
    municipioSeleccionado,
    sectorSeleccionado,
    tipoFormularioSeleccionado,
    data,
  ]);

  useEffect(() => {
    if (visitasPorTipo) {
      const data = Object.keys(visitasPorTipo).map((key, index) => {
        const registrado = visitasPorTipo[key].registrado;
        const pendiente = visitasPorTipo[key].pendiente;
        const total = registrado + pendiente;
        const porcentaje = total > 0 ? (registrado / total) * 100 : 0; // Evita división por cero

        return {
          key: index,
          nombre: key,
          registrado,
          pendiente,
          color: visitasPorTipo[key].color,
          porcentaje,
        };
      });

      setTableData(data);
    }
  }, [visitasPorTipo]); // Se ejecuta cuando visitasPorTipo cambia
  if (!data) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin size="large" />
        <p style={{ marginTop: 16, fontSize: 16, color: "#888" }}>
          Cargando datos...
        </p>
      </div>
    );
  }

  const columns = [
    {
      title: "Codigo SIR",
      dataIndex: "codigo_sir",
      key: "codigo_sir",
      sorter: (a, b) => a.codigo_sir.localeCompare(b.codigo_sir),
      width: 150,
    },
    {
      title: "Nombre",
      dataIndex: "nombre_if",
      key: "nombre_if",
      width: 150,
    },
    {
      title: "Género",
      dataIndex: "sexo_sir",
      key: "sexo_sir",
      width: 100,
    },

    {
      title: "Sector",
      dataIndex: "sector",
      key: "sector",
      width: 100,
    },

    {
      title: "Nombre proyecto",
      dataIndex: "nombre_proyecto",
      key: "nombre_proyecto",
      width: 150,
    },
    {
      title: "Codigo PRE",
      dataIndex: "codigo_pre",
      key: "codigo_pre",
      width: 150,
    },

    {
      title: "Departamento",
      dataIndex: "departamento",
      key: "departamento",
      width: 150,
    },
    {
      title: "Municipio",
      dataIndex: "municipio",
      key: "municipio",
      width: 150,
    },
    {
      title: "Consentimiento",
      dataIndex: "detalle_1",
      key: "detalle_1",
      width: 150,

      render: (_, record) => {
        const detalle = record.detalles.find((d) => d.id === 1);
        return detalle ? renderEstado(detalle.estado) : "N/A";
      },
    },
    {
      title: "Diagnóstico",
      dataIndex: "detalle_2",
      key: "detalle_2",
      width: 150,

      render: (_, record) => {
        const detalle = record.detalles.find((d) => d.id === 2);
        return detalle ? renderEstado(detalle.estado) : "N/A";
      },
    },
    {
      title: "Análisis de capacidades",
      dataIndex: "detalle_3",
      key: "detalle_3",
      width: 150,

      render: (_, record) => {
        const detalle = record.detalles.find((d) => d.id === 3);
        return detalle ? renderEstado(detalle.estado) : "N/A";
      },
    },
    {
      title: "Autorización de imagen",
      dataIndex: "detalle_4",
      key: "detalle_4",
      width: 150,

      render: (_, record) => {
        const detalle = record.detalles.find((d) => d.id === 4);
        return detalle ? renderEstado(detalle.estado) : "N/A";
      },
    },
    {
      title: "Acta de inicio",
      dataIndex: "detalle_5",
      key: "detalle_5",
      width: 150,

      render: (_, record) => {
        const detalle = record.detalles.find((d) => d.id === 5);
        return detalle ? renderEstado(detalle.estado) : "N/A";
      },
    },
    {
      title: "Porcentaje",
      dataIndex: "porcentaje",
      key: "porcentaje",
      width: 150,

      render: (_, record) => {
        const totalFormularios = 5;
        const completados = record.detalles.filter(
          (d) => d.estado === "registrado"
        ).length;
        const porcentaje = (completados / totalFormularios) * 100;

        return (
          <Progress
            percent={porcentaje.toFixed(0)}
            status={porcentaje === 100 ? "success" : "active"}
            strokeColor={porcentaje === 100 ? "#52c41a" : "#1890ff"}
          />
        );
      },
    },
  ];

  // Función para mostrar un Tag con colores según el estado
  const renderEstado = (estado) => {
    return estado === "registrado" ? (
      <Tag color="green">Registrado</Tag>
    ) : (
      <Tag color="red">Pendiente</Tag>
    );
  };

  const columns_2 = [
    {
      title: "Formulario",
      dataIndex: "nombre",
      key: "nombre",
    },
    {
      title: "Registrados",
      dataIndex: "registrado",
      key: "registrado",
      render: (text) => (
        <Tag
          color="#28A745"
          style={{
            fontWeight: "bold",
            color: "#0F0F0F",
            backgroundColor: "#28A745",
          }}
        >
          {text}
        </Tag>
      ),
    },
    {
      title: "Pendientes",
      dataIndex: "pendiente",
      key: "pendiente",
      render: (text) => (
        <Tag
          color="#D4D2D2"
          style={{
            fontWeight: "bold",
            color: "#0F0F0F",
            backgroundColor: "#D4D2D2",
          }}
        >
          {text}
        </Tag>
      ),
    },

    {
      title: "Avance (%)",
      dataIndex: "porcentaje",
      key: "porcentaje",
      render: (porcentaje) => (
        <Progress
          percent={porcentaje.toFixed(0)}
          status={porcentaje === 100 ? "success" : "active"}
          strokeColor={porcentaje === 100 ? "#52c41a" : "#1890ff"}
        />
      ),
    },
  ];

  return (
    <Card style={{ padding: 20 }}>
      <Tag
        color="#D0E0F2"
        style={{
          color: "#145BAD",
          fontSize: "25px",
          fontWeight: "bold",
          padding: "8px 15px",
          borderRadius: "8px",
          textAlign: "center",
          display: "block",
          marginBottom: "15px",
        }}
      >
        INFORME PAATI
      </Tag>
      {/* Filtros */}
      <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
        <Col xs={24} sm={8} md={5}>
          <Select
            placeholder="Selecciona un Departamento"
            style={{ width: "100%" }}
            value={departamentoSeleccionado}
            onChange={(value) => {
              setDepartamentoSeleccionado(value);
              setMunicipioSeleccionado(null);
            }}
            disabled={!listDepartamento || listDepartamento.length === 0} // Asegura que listMunicipio es válido
            showSearch
            optionFilterProp="children" // busca dentro del texto de las opciones
          >
            {listDepartamento.map((dep) => (
              <Option key={dep} value={dep}>
                {dep}
              </Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} sm={8} md={5}>
          <Select
            placeholder="Selecciona un Municipio"
            style={{ width: "100%" }}
            value={municipioSeleccionado || undefined} // Evita null
            onChange={(value) => setMunicipioSeleccionado(value)}
            disabled={!listMunicipio || listMunicipio.length === 0} // Asegura que listMunicipio es válido
            showSearch
            optionFilterProp="children" // busca dentro del texto de las opciones
          >
            {listMunicipio?.map((mun) => (
              <Option key={mun} value={mun}>
                {mun}
              </Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} sm={6} md={5}>
          <Select
            placeholder="Selecciona un Sector"
            style={{ width: "100%" }}
            value={sectorSeleccionado}
            onChange={(value) => {
              setSectorSeleccionado(value);
            }}
            disabled={!listSector || listSector.length === 0}
            showSearch
            optionFilterProp="children" // busca dentro del texto de las opciones
          >
            {listSector.map((sec) => (
              <Option key={sec} value={sec}>
                {sec}
              </Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} sm={6} md={5}>
          <Select
            placeholder="Selecciona un formulario"
            style={{ width: "100%" }}
            value={tipoFormularioSeleccionado}
            onChange={(value) => {
              setTipoFormularioSeleccionado(value);
            }}
            disabled={!listTipoformulario || listTipoformulario.length === 0}
            showSearch
            optionFilterProp="children" // busca dentro del texto de las opciones
          >
            {listTipoformulario.map((sec) => (
              <Option key={sec} value={sec}>
                {sec}
              </Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} sm={12} md={2}>
          <Button
            type="primary"
            icon={<ReloadOutlined />}
            onClick={() => {
              setDepartamentoSeleccionado(null);
              setMunicipioSeleccionado(null);
              setSectorSeleccionado(null);
              setTipoFormularioSeleccionado(null);
              procesarDatos(dataOriginal);
            }}
          >
            Restablecer
          </Button>
        </Col>

        <Col xs={24} sm={12} md={2}>
          <Tooltip title="Informes">
            <Button
              type="primary"
              icon={<BarsOutlined />}
              onClick={() => setDrawerVisible(true)}
            >
              Informes
            </Button>
          </Tooltip>
        </Col>
      </Row>

      {/*TOTALIZADORES EN CARDS */}
      <Row gutter={[24, 24]} style={{ margin: "20px 40px" }}>
        <Col xs={24} sm={12} md={6}>
          <Card bordered={false} style={cardStyle}>
            <div style={{ ...iconContainerStyle, backgroundColor: "#0051AE" }}>
              <UserOutlined style={iconStyle} />
            </div>
            <h3
              style={{
                fontSize: 18,
                fontWeight: "bold",
                color: "#0051AE",
                marginBottom: 5,
              }}
            >
              Total Participantes
            </h3>
            <h2 style={total}>{totalParticipantes}</h2>
          </Card>
        </Col>

        <Col xs={24} sm={12} md={6}>
          <Card bordered={false} style={cardStyle}>
            <div style={{ ...iconContainerStyle, backgroundColor: "#468CDE" }}>
              <ManOutlined style={iconStyle} />
            </div>
            <h3
              style={{
                fontSize: 18,
                fontWeight: "bold",
                color: "#468CDE",
                marginBottom: 5,
              }}
            >
              Total Hombres
            </h3>
            <h2 style={total}>{participantesPorSexo.Hombre}</h2>
          </Card>
        </Col>

        <Col xs={24} sm={12} md={6}>
          <Card bordered={false} style={cardStyle}>
            <div
              style={{ ...iconContainerStyle, backgroundColor: "#ff6474d9" }}
            >
              <WomanOutlined style={iconStyle} />
            </div>
            <h3
              style={{
                fontSize: 18,
                fontWeight: "bold",
                color: "#ff6474d9",
                marginBottom: 5,
              }}
            >
              Total Mujeres
            </h3>
            <h2 style={total}>{participantesPorSexo.Mujer}</h2>
          </Card>
        </Col>

        <Col xs={24} sm={12} md={6}>
          <Card bordered={false} style={cardStyle}>
            {(() => {
              const porcentaje = parseFloat(
                ((registrados * 100) / totalParticipantes).toFixed(2)
              );
              let color = "#52C41A"; // Verde por defecto
              if (porcentaje >= 0 && porcentaje < 30) color = "#FF4D4F"; // Rojo
              else if (porcentaje >= 30 && porcentaje < 60)
                color = "#FFCE00"; // Amarillo
              else if (porcentaje >= 60 && porcentaje < 100) color = "#FA8C16"; // Naranja

              return (
                <>
                  <div
                    style={{ ...iconContainerStyle, backgroundColor: color }}
                  >
                    <CheckCircleOutlined style={iconStyle} />
                  </div>
                  <h3
                    style={{
                      fontSize: 18,
                      fontWeight: "bold",
                      color,
                      marginBottom: 5,
                    }}
                  >
                    Porcentaje de Avance
                  </h3>
                  <h2 style={total}>{porcentaje} %</h2>
                </>
              );
            })()}
          </Card>
        </Col>
      </Row>

      <Card style={{ padding: 20 }}>
        <Tag
          color="#D0E0F2"
          style={{
            color: "#145BAD",
            fontSize: "20px",
            fontWeight: "bold",
            padding: "8px 15px",
            borderRadius: "8px",
            textAlign: "left",
            display: "block",
            marginBottom: "15px",
          }}
        >
          INFORMACIÓN GENERAL
        </Tag>

        <Row gutter={[16]} style={{ marginTop: 20 }}>
          {/*Grafico participantes por departamento     */}
          <Col xs={24} sm={24} md={12} lg={8}>
            <ChartCard
              title={
                departamentoSeleccionado
                  ? `Participantes por municipio en ${departamentoSeleccionado}`
                  : "Participantes por departamento"
              }
              data={{
                labels: departamentoSeleccionado
                  ? Object.keys(participantesPorMunicipio)
                  : Object.keys(participantesPorDepartamento),
                datasets: [
                  {
                    label: municipioSeleccionado
                      ? "Municipio"
                      : departamentoSeleccionado
                      ? "Departamento"
                      : "Departamento",
                    data: departamentoSeleccionado
                      ? Object.values(participantesPorMunicipio)
                      : Object.values(participantesPorDepartamento),
                    backgroundColor: "#145BAD",
                    borderRadius: 5,
                    barThickness: 40,
                  },
                ],
              }}
              chartType="bar"
            />
          </Col>
          {/* Gráfico participantes por sector */}
          <Col xs={24} sm={24} md={12} lg={8}>
            <ChartCard
              title="Participantes por sector"
              data={{
                labels: Object.keys(participantesPorSector),
                datasets: [
                  {
                    label: "Sector",
                    data: Object.values(participantesPorSector),
                    backgroundColor: "#5B93D3",
                    borderRadius: 5, // Bordes redondeados en las barras
                    barThickness: 40, // Define el grosor de las barras
                  },
                ],
              }}
              chartType="bar"
            />
          </Col>
          {/* Gráfico Participantes por Genero */}
          <Col xs={24} sm={24} md={12} lg={8}>
            <ChartCard
              title="Participantes por género"
              chartType="pie"
              showAsPercentage={true} // ✅ Se asegura de mostrar los datos como porcentaje
              data={{
                labels: ["Hombre", "Mujer"],
                datasets: [
                  {
                    label: "Género",
                    data: Object.values(participantesPorSexo),
                    backgroundColor: ["#145BAD", "#5B93D3"],
                  },
                ],
              }}
            />

            {/* Tabla Resumen */}
            <Card
              style={{
                borderRadius: 20,
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                backdropFilter: "blur(10px)",
                padding: "16px",
                marginTop: "16px",
              }}
            >
              <Table
                dataSource={[
                  {
                    key: "hombre",
                    categoria: "Hombres",
                    cantidad: participantesPorSexo["Hombre"] || 0,
                  },
                  {
                    key: "mujer",
                    categoria: "Mujeres",
                    cantidad: participantesPorSexo["Mujer"] || 0,
                  },
                ].map((item) => {
                  const total = Object.values(participantesPorSexo).reduce(
                    (acc, val) => acc + val,
                    0
                  );
                  return {
                    ...item,
                    porcentaje:
                      total > 0
                        ? ((item.cantidad / total) * 100).toFixed(1) + "%"
                        : "0%",
                  };
                })}
                columns={[
                  {
                    title: "Categoría",
                    dataIndex: "categoria",
                    key: "categoria",
                  },
                  { title: "Cantidad", dataIndex: "cantidad", key: "cantidad" },
                  {
                    title: "Porcentaje",
                    dataIndex: "porcentaje",
                    key: "porcentaje",
                  },
                ]}
                pagination={false}
                size="small"
                rowClassName={() => "small-row"}
              />
            </Card>
          </Col>
        </Row>
      </Card>

      <Card style={{ padding: 20 }}>
        <Tag
          color="#D0E0F2"
          style={{
            color: "#145BAD",
            fontSize: "20px",
            fontWeight: "bold",
            padding: "8px 15px",
            borderRadius: "8px",
            textAlign: "left",
            display: "block",
            marginBottom: "15px",
          }}
        >
          REPORTE DE AVANCES
        </Tag>

        <Row gutter={[16]} style={{ marginTop: 40 }}>
          {/*Porcentaje de registro por formulario*/}
          <Col xs={24} sm={24} md={12} lg={8}>
            <ChartCard
              title="Porcentaje de registro por formulario"
              chartType="bar"
              showAsPercentage={true} // ✅ Se asegura de mostrar los datos como porcentaje
              data={{
                labels: Object.keys(visitasPorTipo),
                datasets: [
                  {
                    label: "Registrado",
                    data: Object.values(visitasPorTipo).map((v) =>
                      v.registrado + v.pendiente > 0
                        ? (v.registrado / (v.registrado + v.pendiente)) * 100
                        : 0
                    ),
                    backgroundColor: "#28A745",
                    stack: "Stack 1",
                  },
                  {
                    label: "Pendiente",
                    data: Object.values(visitasPorTipo).map((v) =>
                      v.registrado + v.pendiente > 0
                        ? (v.pendiente / (v.registrado + v.pendiente)) * 100
                        : 0
                    ),
                    backgroundColor: "#D4D2D2",
                    stack: "Stack 1",
                  },
                ],
              }}
            />
          </Col>

          {/*Resumen de registros por formulario*/}
          <Col xs={24} sm={24} md={12} lg={8}>
            <Card
              style={{
                position: "relative",
                borderRadius: 20,
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                backdropFilter: "blur(10px)",
                paddingTop: "30px",
                marginTop: "20px",
              }}
            >
              <div
                style={{
                  height: "400px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  overflowX: "auto",
                }}
              >
                <Table
                  dataSource={tableData}
                  columns={columns_2}
                  rowKey="nombre"
                  bordered
                  pagination={false}
                />
              </div>
            </Card>
          </Col>

          {/*Estado de Participantes - Avance*/}
          <Col xs={24} sm={24} md={12} lg={8}>
            <ChartCard
              title="Estado de participantes - Avance"
              showAsPercentage={true} // ✅ Se asegura de mostrar los datos como porcentaje
              chartType="doughnut"
              data={{
                labels: ["Registrados", "Pendientes"],
                datasets: [
                  {
                    label: "Participantes",
                    data: [registrados, pendientes],
                    backgroundColor: ["#28A745", "#D4D2D2"],
                    hoverOffset: 10,
                  },
                ],
              }}
            />

            {/* Tabla Resumen */}
            <Table
              dataSource={[
                {
                  key: "registrados",
                  categoria: "Registrados",
                  cantidad: registrados,
                },
                {
                  key: "pendientes",
                  categoria: "Pendientes",
                  cantidad: pendientes,
                },
              ].map((item) => {
                const total = registrados + pendientes;
                return {
                  ...item,
                  porcentaje:
                    total > 0
                      ? ((item.cantidad / total) * 100).toFixed(1) + "%"
                      : "0%",
                };
              })}
              columns={[
                {
                  title: "Categoría",
                  dataIndex: "categoria",
                  key: "categoria",
                  align: "center",
                },
                {
                  title: "Cantidad",
                  dataIndex: "cantidad",
                  key: "cantidad",
                  align: "center",
                },
                {
                  title: "Porcentaje",
                  dataIndex: "porcentaje",
                  key: "porcentaje",
                  align: "center",
                },
              ]}
              pagination={false}
              size="small"
              rowClassName={() => "small-row"}
              style={{ marginTop: "8px" }}
            />
          </Col>
        </Row>

        <Row gutter={[16]} style={{ marginTop: 40 }}>
          <Col xs={24} sm={24} md={24} lg={24}>
            <div style={{ overflowX: "auto", marginTop: 30 }}>
              <Table
                dataSource={dataFilter}
                columns={columns}
                rowKey="id"
                scroll={{ y: 500, x: "max-content" }}
                bordered
                pagination={{
                  current: currentPage, // página actual
                  pageSize: pageSize, // filas por página
                  total: dataFilter.length, // total de registros
                  showSizeChanger: true,
                  pageSizeOptions: ["10", "20", "50", "100"],
                  showTotal: (total, range) =>
                    `${range[0]}-${range[1]} de ${total} registros`,
                  onChange: (page, size) => {
                    setCurrentPage(page);
                    setPageSize(size);
                  },
                }}
              />
            </div>
          </Col>
        </Row>
      </Card>

      {/* Drawer para mostrar la lista de informes */}
      <Drawer
        title="Informes Disponibles"
        placement="right"
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
      >
        <List
          dataSource={informes}
          renderItem={(item) => (
            <List.Item
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Title level={5} style={{ margin: 0 }}>
                {item.titulo}
              </Title>
              {item.componente}
            </List.Item>
          )}
        />
      </Drawer>
    </Card>
  );
};

export default InformeSeguimientoMonitoreo;
